import { computed, readonly, ref } from "vue";

const hasLoadedInitialChartData = ref(false);
const hasChartUrlCreationAttemptCompleted = ref(false);
const isAppInitialized = computed(() => hasLoadedInitialChartData.value && hasChartUrlCreationAttemptCompleted.value);

function setHasLoadedInitialChartData(value: boolean) {
  hasLoadedInitialChartData.value = value;
}

function setHasChartUrlCreationAttemptCompleted(value: boolean) {
  hasChartUrlCreationAttemptCompleted.value = value;
}

export function useHasChartInitialized() {
  return {
    hasLoadedInitialChartData: readonly(hasLoadedInitialChartData),
    hasChartUrlCreationAttemptCompleted: readonly(hasChartUrlCreationAttemptCompleted),
    isAppInitialized,
    setHasLoadedInitialChartData,
    setHasChartUrlCreationAttemptCompleted
  };
}
